// Utility function to upload a file to a presigned S3 URL
export const uploadFileToPresignedUrl = async ({
    file,
    uploadUrl,
    onProgress,
}: {
    file: File;
    uploadUrl: string;
    onProgress?: (percent: number) => void;
}) => {
    return new Promise<void>((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', uploadUrl, true);
        xhr.setRequestHeader('Content-Type', file.type);

        xhr.upload.onprogress = event => {
            if (event.lengthComputable && onProgress) {
                const percent = Math.round((event.loaded / event.total) * 90) + 10;
                onProgress(percent);
            }
        };

        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                if (onProgress) {
                    onProgress(100);
                }
                resolve();
            } else {
                reject(new Error(`Upload failed: ${xhr.status} ${xhr.statusText}`));
            }
        };

        xhr.onerror = () => {
            reject(new Error('Network error during upload'));
        };
        file.arrayBuffer().then(buff => xhr.send(buff));
    });
};
